// eslint-disable-next-line import/prefer-default-export
export function CalendarIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 2.30078V6.30078M8 2.30078V6.30078M3 10.3008H21M5 4.30078H19C20.1046 4.30078 21 5.19621 21 6.30078V20.3008C21 21.4054 20.1046 22.3008 19 22.3008H5C3.89543 22.3008 3 21.4054 3 20.3008V6.30078C3 5.19621 3.89543 4.30078 5 4.30078Z'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function BarChartIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18 20.3008V10.3008M12 20.3008V4.30078M6 20.3008V14.3008'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function EnvelopeIcon({ color }: { color: string }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6'
        stroke={color || 'white'}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function BriefcaseIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'>
      <path
        d='M16 21.3005V5.30054C16 4.7701 15.7893 4.2614 15.4142 3.88632C15.0391 3.51125 14.5304 3.30054 14 3.30054H10C9.46957 3.30054 8.96086 3.51125 8.58579 3.88632C8.21071 4.2614 8 4.7701 8 5.30054V21.3005M4 7.30054H20C21.1046 7.30054 22 8.19597 22 9.30054V19.3005C22 20.4051 21.1046 21.3005 20 21.3005H4C2.89543 21.3005 2 20.4051 2 19.3005V9.30054C2 8.19597 2.89543 7.30054 4 7.30054Z'
        stroke='#2563EB'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function GlobeIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 22.3008C17.5228 22.3008 22 17.8236 22 12.3008C22 6.77793 17.5228 2.30078 12 2.30078C6.47715 2.30078 2 6.77793 2 12.3008C2 17.8236 6.47715 22.3008 12 22.3008Z'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 12.3008H22'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 2.30078C14.5013 5.03913 15.9228 8.59282 16 12.3008C15.9228 16.0087 14.5013 19.5624 12 22.3008C9.49872 19.5624 8.07725 16.0087 8 12.3008C8.07725 8.59282 9.49872 5.03913 12 2.30078V2.30078Z'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function BusIcon({ stroke = '#2563EB' }: { stroke?: string }) {
  return (
    <svg width='23' height='24' viewBox='0 0 23 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.6071 4.38685H3.28572C2.37839 4.38685 1.64286 5.1279 1.64286 6.04202V15.1455H15.6071M15.6071 4.38685H16.4286C19.1505 4.38685 21.3571 6.60999 21.3571 9.35239V11.0076V15.1455H15.6071M15.6071 4.38685V11.8351V15.1455M8.21429 17.2145C8.21429 18.3571 7.29487 19.2834 6.16072 19.2834C5.02656 19.2834 4.10715 18.3571 4.10715 17.2145C4.10715 16.0718 5.02656 15.1455 6.16072 15.1455C7.29487 15.1455 8.21429 16.0718 8.21429 17.2145ZM18.8929 17.2145C18.8929 18.3571 17.9734 19.2834 16.8393 19.2834C15.7051 19.2834 14.7857 18.3571 14.7857 17.2145C14.7857 16.0718 15.7051 15.1455 16.8393 15.1455C17.9734 15.1455 18.8929 16.0718 18.8929 17.2145Z'
        stroke={stroke}
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function UsersIcon({ stroke = '#2563EB' }: { stroke?: string }) {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17 21.3008V19.3008C17 18.2399 16.5786 17.2225 15.8284 16.4724C15.0783 15.7222 14.0609 15.3008 13 15.3008H5C3.93913 15.3008 2.92172 15.7222 2.17157 16.4724C1.42143 17.2225 1 18.2399 1 19.3008V21.3008M23 21.3008V19.3008C22.9993 18.4145 22.7044 17.5536 22.1614 16.8531C21.6184 16.1526 20.8581 15.6523 20 15.4308M16 3.43078C16.8604 3.65108 17.623 4.15148 18.1676 4.85309C18.7122 5.5547 19.0078 6.41761 19.0078 7.30578C19.0078 8.19395 18.7122 9.05686 18.1676 9.75847C17.623 10.4601 16.8604 10.9605 16 11.1808M13 7.30078C13 9.50992 11.2091 11.3008 9 11.3008C6.79086 11.3008 5 9.50992 5 7.30078C5 5.09164 6.79086 3.30078 9 3.30078C11.2091 3.30078 13 5.09164 13 7.30078Z'
        stroke={stroke}
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function UserIcon({ stroke = '#2563EB' }: { stroke?: string }) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z'
        stroke={stroke}
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function CoinIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1755 4.52303C13.1766 3.29524 10.6731 2.30078 7.58832 2.30078C4.50357 2.30078 2.00224 3.29635 2 4.52303M2 4.52303C2 5.75082 4.50133 6.74527 7.58832 6.74527C10.6753 6.74527 13.1766 5.75082 13.1766 4.52303L13.1766 13.1453M2 4.52303V17.8564C2.00112 19.0842 4.50245 20.0787 7.58832 20.0787C9.08487 20.0787 10.4361 19.842 11.4387 19.4609M2.00112 8.9675C2.00112 10.1953 4.50245 11.1897 7.58944 11.1897C10.6764 11.1897 13.1778 10.1953 13.1778 8.9675M11.5057 14.9954C10.4976 15.3899 9.11505 15.6343 7.58832 15.6343C4.50245 15.6343 2.00112 14.6398 2.00112 13.4121M19.5272 13.7654C21.4909 15.7177 21.4909 18.8844 19.5272 20.8366C17.5635 22.7888 14.3781 22.7888 12.4144 20.8366C10.4507 18.8844 10.4507 15.7177 12.4144 13.7654C14.3781 11.8132 17.5635 11.8132 19.5272 13.7654Z'
        stroke='#2563EB'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function AlertIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.7002 16.7914C20.147 15.8352 19.4814 14.0164 19.4814 10.8008V10.1352C19.4814 5.98203 16.1533 2.57891 12.0564 2.55078H12.0002C11.0165 2.55201 10.0427 2.74698 9.13434 3.12456C8.22601 3.50213 7.40094 4.05492 6.70624 4.75136C6.01154 5.4478 5.46082 6.27425 5.08552 7.18353C4.71022 8.0928 4.51769 9.0671 4.51892 10.0508V10.8008C4.51892 14.0164 3.85329 15.8352 3.30017 16.7914C3.1664 17.0193 3.0952 17.2785 3.09377 17.5427C3.09235 17.8069 3.16075 18.0668 3.29205 18.2962C3.42335 18.5255 3.6129 18.716 3.84151 18.8485C4.07012 18.981 4.32968 19.0508 4.59392 19.0508H8.25017C8.25017 20.0453 8.64526 20.9992 9.34852 21.7024C10.0518 22.4057 11.0056 22.8008 12.0002 22.8008C12.9947 22.8008 13.9486 22.4057 14.6518 21.7024C15.3551 20.9992 15.7502 20.0453 15.7502 19.0508H19.4064C19.6706 19.0525 19.9305 18.9839 20.1595 18.8521C20.3884 18.7203 20.5783 18.5301 20.7095 18.3008C20.8397 18.0702 20.9073 17.8096 20.9056 17.5448C20.904 17.2801 20.8332 17.0203 20.7002 16.7914ZM12.0002 21.3008C11.4042 21.2983 10.8333 21.0605 10.4119 20.639C9.99048 20.2176 9.75264 19.6468 9.75017 19.0508H14.2502C14.2477 19.6468 14.0099 20.2176 13.5884 20.639C13.167 21.0605 12.5961 21.2983 12.0002 21.3008ZM4.59392 17.5508C5.24079 16.4258 6.01892 14.3539 6.01892 10.8008V10.0508C6.01645 9.26374 6.16934 8.48394 6.46882 7.7561C6.7683 7.02825 7.20849 6.36667 7.76414 5.80927C8.3198 5.25187 8.98 4.80962 9.70691 4.50786C10.4338 4.20611 11.2131 4.05078 12.0002 4.05078H12.047C15.3189 4.06953 17.9814 6.80703 17.9814 10.1352V10.8008C17.9814 14.3539 18.7595 16.4258 19.4064 17.5508H4.59392Z'
        fill='#2563EB'
        stroke='#2563EB'
        strokeWidth='0.5'
      />
    </svg>
  );
}

export function MessagesIcon() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.5 11.3008C20.5034 12.6207 20.1951 13.9227 19.6 15.1008C18.8944 16.5126 17.8098 17.7 16.4674 18.5301C15.1251 19.3602 13.5782 19.8002 12 19.8008C10.6801 19.8043 9.37812 19.4959 8.2 18.9008L2.5 20.8008L4.4 15.1008C3.80493 13.9227 3.49656 12.6207 3.5 11.3008C3.50061 9.72257 3.94061 8.17566 4.77072 6.83336C5.60083 5.49106 6.78825 4.40638 8.2 3.70081C9.37812 3.10574 10.6801 2.79737 12 2.80081H12.5C14.5843 2.9158 16.553 3.79557 18.0291 5.27167C19.5052 6.74777 20.385 8.71646 20.5 10.8008V11.3008Z'
        stroke='#2563EB'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function GearIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z'
        stroke='#2563EB'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.1676 7.94004L19.1018 7.82619C18.9204 7.51217 18.8278 7.15475 18.8339 6.79216L18.8639 5.01333C18.87 4.64981 18.6783 4.3116 18.3633 4.13007L15.6266 2.55307C15.3124 2.372 14.9248 2.37524 14.6136 2.56155L13.0945 3.47113C12.7841 3.65704 12.429 3.75522 12.0671 3.75522H11.9354C11.5727 3.75522 11.2169 3.65661 10.906 3.46994L9.37989 2.55377C9.06765 2.36632 8.67819 2.36344 8.36321 2.54625L5.63522 4.12954C5.32173 4.31149 5.13124 4.64883 5.13733 5.01125L5.1673 6.79216C5.1734 7.15475 5.0808 7.51217 4.89941 7.82619L4.83452 7.93852C4.65303 8.25271 4.38949 8.5116 4.07212 8.68748L2.51724 9.54914C2.19854 9.72576 2.00113 10.0617 2.00196 10.4261L2.00911 13.5779C2.00994 13.9401 2.20649 14.2735 2.52297 14.4495L4.07039 15.3104C4.38884 15.4875 4.65283 15.7483 4.83386 16.0646L4.90339 16.186C5.08222 16.4985 5.17341 16.8534 5.16734 17.2133L5.1374 18.9865C5.13127 19.35 5.32294 19.6882 5.63798 19.8698L8.37461 21.4468C8.68883 21.6278 9.07647 21.6246 9.38762 21.4383L10.9067 20.5287C11.2172 20.3428 11.5723 20.2446 11.9341 20.2446H12.0658C12.4285 20.2446 12.7843 20.3432 13.0953 20.5299L14.6213 21.4461C14.9336 21.6335 15.323 21.6364 15.638 21.4536L18.366 19.8703C18.6795 19.6884 18.87 19.351 18.8639 18.9886L18.8339 17.2077C18.8278 16.8451 18.9204 16.4877 19.1018 16.1737L19.1667 16.0613C19.3482 15.7471 19.6117 15.4882 19.9291 15.3124L21.484 14.4507C21.8027 14.2741 22.0001 13.9381 21.9993 13.5738L21.9921 10.4219C21.9913 10.0598 21.7947 9.72638 21.4783 9.55032L19.9271 8.68741C19.611 8.51156 19.3485 8.25327 19.1676 7.94004Z'
        stroke='#2563EB'
        strokeWidth='1.67'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function DocumentIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.3333 9.21429H13.6667V2.64286H3.66667V22.3571H20.3333V9.21429ZM19.6433 7.57143L15.3333 3.323V7.57143H19.6433ZM2.83333 1H15.3333L22 7.57143V23.1786C22 23.3964 21.9122 23.6054 21.7559 23.7594C21.5997 23.9135 21.3877 24 21.1667 24H2.83333C2.61232 24 2.40036 23.9135 2.24408 23.7594C2.0878 23.6054 2 23.3964 2 23.1786V1.82143C2 1.60357 2.0878 1.39464 2.24408 1.24059C2.40036 1.08654 2.61232 1 2.83333 1ZM7 12.5H17V14.1429H7V12.5ZM7 7.57143H11.1667V9.21429H7V7.57143ZM7 17.4286H17V19.0714H7V17.4286Z'
        fill='#2563EB'
      />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg
      width='18px'
      height='24px'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5 6.5V3.5C4.5 1.84315 5.84315 0.5 7.5 0.5C9.15685 0.5 10.5 1.84315 10.5 3.5V6.5M2.5 6.5H12.5C13.0523 6.5 13.5 6.94772 13.5 7.5V13.5C13.5 14.0523 13.0523 14.5 12.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V7.5C1.5 6.94772 1.94772 6.5 2.5 6.5Z'
        stroke='#F2994A'
      />
    </svg>
  );
}

export function LockIconSmall() {
  return (
    <svg
      width='12px'
      height='13.33px'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5 6.5V3.5C4.5 1.84315 5.84315 0.5 7.5 0.5C9.15685 0.5 10.5 1.84315 10.5 3.5V6.5M2.5 6.5H12.5C13.0523 6.5 13.5 6.94772 13.5 7.5V13.5C13.5 14.0523 13.0523 14.5 12.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V7.5C1.5 6.94772 1.94772 6.5 2.5 6.5Z'
        stroke='#F2994A'
      />
    </svg>
  );
}
